<template>

    <div>
        <div class="modal-dimmer" v-if="modalState" @click="fModalClose()" ></div>

        <div v-bind:class="[{ 'open': modalState }, 'atlass-modal', modalClass ]" >
            <div class="atlass-modal-close" > <a @click="fModalClose()" class="d-inline-block" > <font-awesome-icon icon="times" v-if="modalDismissable" /> </a> </div>
            
            <watcher v-if="modalState && modalComponent == 'watcher'" :ID="modalData" ></watcher>
            
            <product v-if="modalState && modalComponent == 'product'" :ID="modalData" ></product>
            
            <automation v-if="modalState && modalComponent == 'automation'" :ID="modalData" ></automation>
            
            <lead v-if="modalState && modalComponent == 'lead'" :ID="modalData" ></lead>
            
            <orders v-if="modalState && modalComponent == 'orders'" :data="modalData" ></orders>
            <ordersWrapper v-if="modalState && modalComponent == 'orders-wrapper'" :data="modalData" ></ordersWrapper>
            
            <engagement-leads v-if="modalState && modalComponent == 'engagement-leads'" :data="modalData" ></engagement-leads>
            
            <engagement v-if="modalState && modalComponent == 'engagement'" :data="modalData" ></engagement>
            
            <ads v-if="modalState && modalComponent == 'ads'" :data="modalData" ></ads>
            
            <OrganizationNew v-if="modalState && modalComponent == 'organizationNew'" :data="modalData" ></OrganizationNew>
            
            <user v-if="modalState && modalComponent == 'user'" :data="modalData" ></user>
            
            <passwordChange v-if="modalState && modalComponent == 'passwordChange'" :data="modalData" ></passwordChange>
            
            <Funnels v-if="modalState && modalComponent == 'funnels'" :data="modalData" ></Funnels>
            
            <funnel v-if="modalState && modalComponent == 'funnel'" :ID="modalData" ></funnel>
            
            <leadToMerge v-if="modalState && modalComponent == 'leadToMerge'" :data="modalData" ></leadToMerge>
            
            <importEvents v-if="modalState && modalComponent == 'importEvents'" :data="modalData" ></importEvents>
            
            <billing v-if="modalState && modalComponent == 'billing'" ></billing>
            
            <notifications v-if="modalState && modalComponent == 'notifications'" :data="modalData" ></notifications>
            
        </div>
    </div>

</template>

<script>    
    
import lead from '@/components/lead.vue'        
import watcher from '@/components/watcher.vue'        
import product from '@/components/product.vue'        
import automation from '@/components/automation.vue'        
import orders from '@/components/orders.vue'        
import ordersWrapper from '@/components/orders-wrapper.vue'        
import engagement from '@/components/engagement.vue'        
import engagementLeads from '@/components/engagement-leads.vue'        
import ads from '@/components/ads.vue'        
import OrganizationNew from '@/components/organizationNew.vue'        
import user from '@/components/user.vue'        
import passwordChange from '@/components/passwordChange.vue'        
import Funnels from '@/templates/setup/Funnels.vue';    
import funnel from '@/components/funnel.vue'    
import leadToMerge from '@/components/leadToMerge.vue'    
import importEvents from '@/components/importEvents.vue'    
import notifications from '@/components/notifications.vue'   
    
import billing from '@/templates/settings/Billing.vue'    
    
export default {
    name: 'modal',
    components:{
        lead,
        orders,
        ordersWrapper,
        engagementLeads,
        engagement,
        watcher,
        product,
        automation,
        OrganizationNew,
        user,
        ads,
        passwordChange,
        Funnels,
        funnel,
        leadToMerge,
        importEvents,
        billing,
        notifications
    },
    props:{
        modalData: { type: [String, Object, Array], default: null },
        modalState: { type: [Boolean], default : false }, 
        modalClass: { type: [ String], default: '' },
        modalComponent: { type: [ String], default: '' },
        modalDismissable: { type: [Boolean], default: true }
    },
    methods:{
        fModalClose(){
            if( this.modalDismissable ){
                this.$parent.modalState = false;
                this.$parent.modalData = null
            }
                
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>

</style>



// WEBPACK FOOTER //
// src/components/modal.vue